"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("../../utils/styled-components"));
var Returnslip32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("g", { fill: "currentColor", fillRule: "nonzero" },
        react_1.default.createElement("path", { d: "M12.5 23a.5.5 0 110 1H7a1 1 0 01-1-1V4a1 1 0 011-1h16a1 1 0 011 1v9.5a.5.5 0 11-1 0V4H7v19z" }),
        react_1.default.createElement("path", { d: "M21 29a7 7 0 100-14 7 7 0 000 14zm0-1a6 6 0 110-12 6 6 0 010 12zM21 10.5a.5.5 0 00-.5-.5h-11a.5.5 0 000 1h11a.5.5 0 00.5-.5M21 7.5a.5.5 0 00-.5-.5h-11a.5.5 0 000 1h11a.5.5 0 00.5-.5M21 13.5a.5.5 0 00-.5-.5h-11a.5.5 0 000 1h11a.5.5 0 00.5-.5" }),
        react_1.default.createElement("g", { stroke: "currentColor", strokeWidth: 0.5 },
            react_1.default.createElement("path", { d: "M18.067 20.3h4.666c1.228 0 2.223 1.12 2.223 2.5s-.995 2.5-2.223 2.5H18.29c-.123 0-.222.112-.222.25s.1.25.222.25h4.444c1.473 0 2.667-1.343 2.667-3s-1.194-3-2.667-3h-4.666c-.123 0-.223.112-.223.25s.1.25.223.25z" }),
            react_1.default.createElement("path", { d: "M20.166 17.842c.102-.077.24-.046.308.07a.27.27 0 01-.062.346h0l-2.39 1.792 2.39 1.792a.27.27 0 01.062.347c-.068.115-.206.146-.308.069l-2.667-2-.011-.009a.24.24 0 01-.05-.06l.026.034-.01-.01a.245.245 0 01-.008-.01l-.009-.014a.26.26 0 01-.037-.138.283.283 0 01.037-.14l.008-.012a.235.235 0 01.054-.057l-.034.033.012-.014a.228.228 0 01.011-.01l.011-.009z" }))))); };
var StyledReturnslip32 = styled_components_1.default(Returnslip32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledReturnslip32;
var templateObject_1;
//# sourceMappingURL=Returnslip32.js.map